<template>
  <div class="page-maindiv">
    <!-- Main -->
    <div class="area-main asset-main">
      <div class="spinner-div"><b-spinner class="spinner" label="Busy" v-show="loading"></b-spinner></div>
      <b-link :to="{name: 'assets', params: {idCollection: collectionId, previousPageLink: previousPageLink, previousPageTitle: previousPageTitle}}"
              style="text-decoration: none;color: #2c3e50" v-if="!loading && collectionId != ''">
        <div class="breadcrumb">
          <b-icon class="backimage" aria-label="back" icon="chevron-compact-left"></b-icon>
          {{ collectionName }}
        </div>
      </b-link>
      <div class="asset-main-top" v-if="!loading">
        <div class="asset-main-top-left">
          <h1 class="asset-main-title">
            {{ assetName1 }}
          </h1>
          <h2 class="asset-subtitle1 mt-2 mb-0" v-if="!$utilities.isEmpty(assetName2)">
            {{ assetName2 }}
          </h2>
          <h3 class="asset-subtitle2 mt-1" v-if="!$utilities.isEmpty(assetName3)">
            {{ assetName3 }}
          </h3>
<!--          <div class="asset-description-title" v-if="!$utilities.isEmpty(assetDescription)">-->
<!--            {{  $t('descrizione') }}-->
<!--          </div>-->
          <div class="asset-description-text mt-2" v-if="!$utilities.isEmpty(assetDescription)" v-html="assetDescription"/>
          <div class="asset-catalog-title mt-3"
               v-if="!$utilities.isEmpty(assetAuthor) || !$utilities.isEmpty(assetBuilder) || !$utilities.isEmpty(assetDate) || !$utilities.isEmpty(assetPlace)
                   || !$utilities.isEmpty(assetMaterial) || !$utilities.isEmpty(assetSize) || !$utilities.isEmpty(assetInventory)
                   || !$utilities.isEmpty(assetObjectID) || !$utilities.isEmpty(assetObjectNCT) || !$utilities.isEmpty(assetCollection)">
            {{  $t('catalogo') }}
          </div>
          <div class="asset-catalog-text asset-description-catalog mt-2"
               v-if="!$utilities.isEmpty(assetAuthor) || !$utilities.isEmpty(assetBuilder) || !$utilities.isEmpty(assetDate) || !$utilities.isEmpty(assetPlace)
                   || !$utilities.isEmpty(assetMaterial) || !$utilities.isEmpty(assetSize) || !$utilities.isEmpty(assetInventory)
                   || !$utilities.isEmpty(assetObjectID) || !$utilities.isEmpty(assetObjectNCT) || !$utilities.isEmpty(assetCollection)">
            <p v-if="!$utilities.isEmpty(assetAuthor)" v-html="'<b class=\'asset-catalog-titles\'>' + $t('catalogo_autore') + '</b>' + assetAuthor">
            </p>
            <p v-if="!$utilities.isEmpty(assetBuilder)" v-html="'<b class=\'asset-catalog-titles\'>' + $t('catalogo_costruttore') + '</b>' + assetBuilder">
            </p>
            <p v-if="!$utilities.isEmpty(assetDate)" v-html="'<b class=\'asset-catalog-titles\'>' + $t('catalogo_data') + '</b>' + assetDate">
            </p>
            <p v-if="!$utilities.isEmpty(assetPlace)" v-html="'<b class=\'asset-catalog-titles\'>' + $t('catalogo_luogo') + '</b>' + assetPlace">
            </p>
            <p v-if="!$utilities.isEmpty(assetMaterial)" v-html="'<b class=\'asset-catalog-titles\'>' + $t('catalogo_materia') + '</b>' + assetMaterial">
            </p>
            <p v-if="!$utilities.isEmpty(assetSize)" v-html="'<b class=\'asset-catalog-titles\'>' + $t('catalogo_dimensioni') + '</b>' + assetSize">
            </p>
            <p v-if="!$utilities.isEmpty(assetInventory)" v-html="'<b class=\'asset-catalog-titles\'>' + $t('catalogo_inventario') + '</b>' + assetInventory">
            </p>
            <p v-if="!$utilities.isEmpty(assetObjectID)" v-html="'<b class=\'asset-catalog-titles\'>' + $t('catalogo_codice_oggetto') + '</b>' + assetObjectID">
            </p>
            <p v-if="!$utilities.isEmpty(assetObjectNCT)" v-html="'<b class=\'asset-catalog-titles\'>' + $t('catalogo_codice_nct') + '</b>' + assetObjectNCT">
            </p>
            <p v-if="!$utilities.isEmpty(assetCollection)" v-html="'<b class=\'asset-catalog-titles\'>' + $t('catalogo_collezione') + '</b>' + assetCollection">
            </p>
            <p class="font-italic" v-if="!$utilities.isEmpty(assetVisibility)" v-html="'<b class=\'asset-catalog-titles\'>' + assetVisibility + '</b>'">
            </p>
          </div>
        </div>
        <div class="asset-main-top-right" v-if="images.length > 0">
          <div class="asset-images mb-1">
            <transition name="fade">
              <b-img
                  :src="currentImage.preview"
                  :key="currentImage.id"
                  :alt="assetName1"
                  fluid
                  style="align-self: center; cursor: zoom-in; object-fit: cover;"
                  @click="showOverlay = !showOverlay"
              />
            </transition>
            <div tabindex="-1" class="overlayzoom" v-if="showOverlay" oncontextmenu="return false">
              <pinch-zoom style="width: 100%; height: 100%">
                <b-img
                    :src="currentImage.full"
                    :alt="assetName1"
                    style="align-self: center"
                />
              </pinch-zoom>
              <b-icon id="image-full-close-icon" @click="showOverlay = false" aria-label="Close" icon="arrows-angle-contract"></b-icon>
            </div>
            <p class="asset-credits mt-2" v-if="!$utilities.isEmpty(imageTitle)">
              {{ imageTitle }}
            </p>
            <p class="asset-credits mt-2" v-if="!$utilities.isEmpty(imageCredits)">
              <strong>
                {{ $t('credits') }}
              </strong>
              {{ ": " + imageCredits }}
            </p>
            <!-- Hidden images (to pre-fetch them) -->
            <b-img
                hidden
                v-for="image in filteredImages"
                :key="image.preview"
                :src="image.preview"
            />
          </div>
          <div class="asset-thumbnails" v-if="filteredImages.length > 1">
            <b-img
                v-for="image in filteredImages"
                :key="image.thumbnail"
                :src="image.thumbnail"
                :alt="assetName1"
                fluid
                class="asset-thumbnail"
                @click="currentImage = image"
            />
          </div>
        </div>
      </div>
      <div class="asset-others" v-if="!loading && relatedAssets.length > 0">
        <div class="asset-others-top">
          <div class="asset-others-title">
            {{ $t('beni_correlati') }}
          </div>
          <div class="asset-others-hr-div">
            <hr style="border-top: 2px solid #DCAC00;margin: 0"/>
          </div>
        </div>
        <div class="asset-others-bottom" v-if="!loadingRelated">
          <div class="spinner-div"><b-spinner class="spinner" label="Busy" v-if="loadingRelated"></b-spinner></div>
          <vue-horizontal ref="horizontal" responsive style="display: flex; width: 100%" v-observe-visibility="{
              callback: visibilityChanged,
              once: true,
            }">
            <b-card
                :class="asset.id == idAsset ? 'asset-card-selected' : 'asset-card'"
                no-body
                border-variant="white"
                v-for="asset in relatedAssets"
                :key="asset.id"
            >
              <b-link :to="{ path: '/asset/' + asset.id, query: { ids: ids } }" style="text-decoration: none;color: #2c3e50;width: 100%">
                <b-card-text class="asset-card-title">
                  {{ $utilities.getTranslation(asset, "nome", $i18n.locale) }}
                </b-card-text>
                <b-card-text class="asset-card-title2">
                  {{ $utilities.getTranslation(asset, "nome2", $i18n.locale) }}
                </b-card-text>
                <b-card-text class="asset-card-title3">
                  {{ $utilities.getTranslation(asset, "nome3", $i18n.locale) }}
                </b-card-text>
              </b-link>
              <b-link :to="{ path: '/asset/' + asset.id, query: { ids: ids } }" style="text-decoration: none;color: #2c3e50;width: 100%;height: 100%">
                <div class="asset-card-div-image">
                  <b-card-img class="asset-card-image" :src="asset.image" :alt="$utilities.getTranslation(asset, 'nome', $i18n.locale)" top></b-card-img>
                </div>
              </b-link>
            </b-card>
          </vue-horizontal>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueHorizontal from 'vue-horizontal';

export default {
  name: 'Asset',
  components: {VueHorizontal},
  data: function() {
    return {
      showOverlay: false,
      structure: null,
      collection: null,
      asset: null,
      relatedAssets: [],
      images: [],
      loading: true,
      loadingRelated: true,
      currentImage: null,
      currentRelatedIndex: 0
    };
  },
  watch: {
    $route() {
      this.showOverlay = false;
      this.structure = null;
      this.collection = null;
      this.asset = null;
      this.relatedAssets = [];
      this.images = [];
      this.loading = true;
      this.loadingRelated = true;
      this.currentImage = null;
      this.fetchAsset();
      this.fetchRelatedAssets();
    }
  },
  created() {
    this.fetchAsset();
    this.fetchRelatedAssets();
  },
  computed: {
    assetName1() {
      return this.$utilities.getTranslation(this.asset, "nome", this.$i18n.locale);
    },
    assetName2() {
      return this.$utilities.getTranslation(this.asset, "nome2", this.$i18n.locale);
    },
    assetName3() {
      return this.$utilities.getTranslation(this.asset, "nome3", this.$i18n.locale);
    },
    assetDescription() {
      return this.$utilities.getTranslation(this.asset, "descrizione", this.$i18n.locale);
    },
    assetAuthor() {
      return this.$utilities.getTranslation(this.asset, "catalogo_autore", this.$i18n.locale);
    },
    assetBuilder() {
      return this.$utilities.getTranslation(this.asset, "catalogo_costruttore", this.$i18n.locale);
    },
    assetDate() {
      return this.$utilities.getTranslation(this.asset, "catalogo_data", this.$i18n.locale);
    },
    assetPlace() {
      return this.$utilities.getTranslation(this.asset, "catalogo_luogo", this.$i18n.locale);
    },
    assetMaterial() {
      return this.$utilities.getTranslation(this.asset, "catalogo_materia", this.$i18n.locale);
    },
    assetSize() {
      return this.$utilities.getTranslation(this.asset, "catalogo_dimensioni", this.$i18n.locale);
    },
    assetInventory() {
      return this.$utilities.getTranslation(this.asset, "catalogo_inventario", this.$i18n.locale);
    },
    assetObjectID() {
      return this.$utilities.getTranslation(this.asset, "catalogo_codice_oggetto", this.$i18n.locale);
    },
    assetObjectNCT() {
      return this.$utilities.getTranslation(this.asset, "catalogo_codice_nct", this.$i18n.locale);
    },
    assetCollection() {
      return this.$utilities.getTranslation(this.asset, "catalogo_collezione", this.$i18n.locale);
    },
    assetVisibility() {
      if (this.asset.visitabilita === 0)
        return this.$t("bene_non_visitabile");
      else if (this.asset.visitabilita === 1)
        return this.$t("bene_visitabile");
      else if (this.asset.visitabilita === 2)
        return this.$t("bene_non_esposto");
      else if (this.asset.visitabilita === 3)
        return this.$t("bene_in_prestito");
      else
        return null;
    },
    imageCredits() {
      if (this.currentImage != null)
        return this.currentImage.credits;
      else
        return null;
    },
    imageTitle() {
      if (this.currentImage != null)
        return this.$utilities.getFileTranslation(this.currentImage.title, this.$i18n.locale);
      else
        return null;
    },
    filteredImages() {
      const images = this.images;
      return images.sort((a, b) => parseFloat(a.order) - parseFloat(b.order));
    },
    collectionName() {
      return this.$utilities.getTranslation(this.collection, "nome", this.$i18n.locale);
    },
    collectionId() {
      if (this.collection != null)
        return this.collection.id;
      else
        return "";
    },
    idAsset() {
      return this.$route.params.idAsset;
    },
    ids() {
      return this.$route.query.ids;
    },
    relatedIds() {
      if (this.$route.query.ids == null)
        return [];
      const idList = this.$route.query.ids.split(",");
      return idList;
      // return idList.filter(e => e !== this.$route.params.idAsset);
    },
    previousPageLink() {
      if (this.$route.params.previousPageLink != null) {
        this.$session.set("previousPageLink", this.$route.params.previousPageLink);
        return this.$route.params.previousPageLink;
      } else {
        if (this.$session.exists("previousPageLink"))
          return this.$session.get("previousPageLink");
        else
          return null;
      }
    },
    previousPageTitle() {
      if (this.$route.params.previousPageTitle != null) {
        this.$session.set("previousPageTitle", this.$route.params.previousPageTitle);
        return this.$route.params.previousPageTitle;
      } else {
        if (this.$session.exists("previousPageTitle"))
          return this.$session.get("previousPageTitle");
        else
          return null;
      }
    }
  },
  methods: {
    async fetchAsset() {
      // Bene
      const assetData = await this.$client.getItems("beni", {fields: ["id", "id_collezione", "visitabilita", "traduzioni.*"], limit: -1, filter: {
          id: {
            eq: this.idAsset
        }}});
      let asset = assetData.data[0];

      // Collezione
      if (asset.id_collezione != null) {
        const collectionsData = await this.$client.getItems("collezioni", {
          fields: ["id", "id_dipartimento", "traduzioni.*"], filter: {
            id: {
              eq: asset.id_collezione.id
            }
          }
        });
        if (collectionsData.data.length > 0)
          this.collection = collectionsData.data[0];

        // Struttura
        if (this.collection.id_dipartimento != null) {
          const structuresData = await this.$client.getItems("dipartimenti", {
            fields: ["*", "traduzioni.*"], filter: {
              id: {
                eq: this.collection.id_dipartimento.id
              }
            }
          });
          if (structuresData.data.length > 0)
            this.structure = structuresData.data[0];
        }
      }

      const joinsData = await this.$client.getItems("join_beni_directus_files", {fields: ["*"], limit: -1, filter: {
          id_beni: {
            eq: asset.id
          }}});
      let joins = joinsData.data;
      let listOfIdDirectusFiles = "";
      for (let join in joins) {
        listOfIdDirectusFiles += joins[join].id_directus_files + ",";
      }

      const filesData = await this.$client.getFiles({limit: -1, filter: {
        id: {
          in: listOfIdDirectusFiles
        }}});
      let files = filesData.data;

      for (let join in joins) {
        if (asset.id === joins[join].id_beni) {
          const imageId = "" + joins[join].id_directus_files;
          let image = { asset: null, thumbnail: null, preview: null, full: null, credits: "", order: 1000 };
          if (this.currentImage == null)
            this.currentImage = image;
          for (let file in files) {
            if (files[file].id != imageId)
              continue;
            // Immagini
            let assetUrl = this.$client.getAssetUrl(files[file].private_hash, {key: "directus-large-contain"});
            image.preview = assetUrl;
            assetUrl = this.$client.getAssetUrl(files[file].private_hash, {key: "thumbnail"});
            image.thumbnail = assetUrl;
            assetUrl = this.$client.getAssetUrl(files[file].private_hash);
            image.full = assetUrl;
            // Ordine di visualizzazione delle immagini (se esiste)
            if (files[file].metadata != null) {
              if (files[file].metadata.credits != null)
                image.credits = files[file].metadata.credits;
              if (files[file].metadata.order != null) {
                image.order = files[file].metadata.order;
                if (this.currentImage.order > image.order)
                  this.currentImage = image;
              }
            }
            // Titolo (in caso differisca dal titolo dell'oggetto)
            image.title = files[file].description;
            this.images.push(image); // id file
          }
        }
      }
      this.asset = asset;
      console.log(asset);
      this.loading = false;
    },

    async fetchRelatedAssets() {
      if (this.relatedIds.length == 0)
        return;
      const assetsData = await this.$client.getItems("beni", {fields: ["id", "id_collezione", "traduzioni.*"], limit: -1, filter: {
          id: {
            in: this.relatedIds
          }}});
      let assets = assetsData.data;

      const joinsData = await this.$client.getItems("join_beni_directus_files", {fields: ["*"], limit: -1, filter: {
          id_beni: {
            in: this.relatedIds
          }}});
      let joins = joinsData.data;
      let listOfIdDirectusFiles = "";
      for (let join in joins) {
        listOfIdDirectusFiles += joins[join].id_directus_files + ",";
      }

      const filesData = await this.$client.getFiles({limit: -1, filter: {
          id: {
            in: listOfIdDirectusFiles
          }}});
      let files = filesData.data;

      this.currentRelatedIndex = 0;
      let index = 0;
      for (let asset in assets) {
        assets[asset].order = Number.MAX_VALUE;
        assets[asset].image = null;
        assets[asset].numImages = 0;
        if (assets[asset].id == this.idAsset)
          this.currentRelatedIndex = index;

        for (let join in joins) {
          if (assets[asset].id === joins[join].id_beni) {
            assets[asset].numImages++;
            const imageId = "" + joins[join].id_directus_files;
            for (let file in files) {
              if (files[file].id != imageId)
                continue;
              // Immagini
              let assetUrl = this.$client.getAssetUrl(files[file].private_hash, {key: "directus-large-contain"});
              // Ordine di visualizzazione delle immagini (se esiste)
              if (files[file].metadata != null && files[file].metadata.order != null) {
                if (assets[asset].order > files[file].metadata.order) { // si prende l'immagine con order minimo
                  assets[asset].order = files[file].metadata.order;
                  assets[asset].image = assetUrl;
                }
              }
              if (assets[asset].image == null) { // se non è specificato order assegna comunque l'immagine
                assets[asset].image = assetUrl;
              }
            }
          }
        }
        index++;
      }
      this.relatedAssets = assets;
      this.loadingRelated = false;
    },
    visibilityChanged () {
      this.$refs.horizontal.scrollToIndex(this.currentRelatedIndex);
    },
  }
}
</script>

<style>
</style>
